/**
 * Slots for the two screens that are not stages of adding an episode.
 *
 * Numbered past the nine real steps rather than inserted among them, so
 * every existing step keeps its number - which matters more here than it
 * did for movies, because two other places jump straight into step 2:
 * the season wizard's "Add Episodes" handoff, and step 9's "Add More
 * Episodes". Renumbering would have had to chase both.
 */
export const EPISODE_LANDING_STEP = 10;
export const EPISODE_QUEUE_STEP = 11;
